export default "__VITE_ASSET__QRKVGgrx__"